import React from 'react'
import PropTypes from 'prop-types'
import useImage from '@/hooks/useImage'

/**
 * Composant Logo réutilisable
 * Utilise le même logo que la Sidebar
 */
export function Logo({ 
  width = 136, 
  height = 36, 
  className = '', 
  alt = 'Folkyn',
  showPlaceholder = false,
  variant = 'default', // 'default' | 'dark' | 'white' | 'onboarding' (SVG marque onboarding)
  onClick
}) {
  const logoSrcDefault = useImage('Logo.png')
  const logoSrcWhite = useImage('Logo-white.svg')
  const logoSrcOnboarding = useImage('logo-folkyn-onboarding.svg')
  const logoSrc =
    variant === 'white'
      ? logoSrcWhite
      : variant === 'onboarding'
        ? logoSrcOnboarding
        : logoSrcDefault

  if (!logoSrc) {
    if (showPlaceholder) {
      // Placeholder SVG comme dans la Sidebar
      const textColor =
        variant === 'dark' || variant === 'onboarding' ? '#000000' : '#20766F'
      return (
        <svg 
          width={width} 
          height={height} 
          viewBox="0 0 136 36" 
          fill="none"
          className={className}
        >
          <rect width="136" height="36" rx="12" fill="#FFC44D" />
          <text 
            x="68" 
            y="22" 
            textAnchor="middle" 
            fontSize="16" 
            fill={textColor} 
            fontWeight="bold"
          >
            LOGO
          </text>
        </svg>
      )
    }
    
    // Fallback texte simple
    const bgColor = variant === 'dark' || variant === 'onboarding' ? '#000000' : '#20766F'
    const textColor = variant === 'dark' ? '#FFFFFF' : '#FFFFFF'
    
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <div
          className="rounded px-3 py-1 font-bold"
          style={{ 
            fontSize: typeof width === 'number' ? `${width / 4}px` : '16px',
            backgroundColor: bgColor,
            color: textColor
          }}
        >
          FOLKYN
        </div>
      </div>
    )
  }

  // Si variant dark, appliquer un filtre pour assombrir le logo PNG
  // onboarding : SVG déjà en #012635, pas de filtre
  // white (SVG) : pas de filtre pour éviter le flou
  const imageClassName =
    variant === 'dark'
      ? `object-contain brightness-0 ${className}`
      : `object-contain ${className}`

  return (
    <img
      src={logoSrc}
      alt={alt}
      width={width}
      height={height}
      className={imageClassName}
      onClick={onClick}
      style={{ 
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        imageRendering: variant === 'white' || variant === 'onboarding' ? 'crisp-edges' : 'auto',
        cursor: onClick ? 'pointer' : 'default'
      }}
    />
  )
}

Logo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  alt: PropTypes.string,
  showPlaceholder: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'dark', 'white', 'onboarding']),
  onClick: PropTypes.func,
}

